export const tooltip = {
  copy: 'Create a copy of the component for pasting',
  save: 'Save current selected component as custom',
  preview: 'Open dashboard preview',
  theme: 'Toggle between light and dark mode',
  delete: 'Delete current selected component(s)',
  cards: "Switch layout to installation cards",
  grid: "Switch layout to installation table",
  delete_installation: "Delete installationd",
  admin_save: 'Save current selected component as a K-Array component'
}